/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

import { ComponentLinkProxy } from 'src/components/component-link';
import RepositoryLink from 'src/components/repository-link';
import withPadding from 'src/utils/with-padding';

export const RepositoryName = withPadding(
  styled.div({
    fontWeight: 'bold',
    display: 'inline-block',
    textDecoration: 'inherit',
    marginRight: '1em',
  })
);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression
export const FilePath = withPadding(styled.div`
  /* stylelint-disable-line block-no-empty */
`);

export const FileLink = styled(ComponentLinkProxy)({
  fontWeight: 'bold',
});

export const DirLink = styled(ComponentLinkProxy)({
  color: 'inherit',
});

export const repositorySubtleLink = styled(RepositoryLink)({
  color: 'inherit',
});

export const FileLinkWrapper = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  paddingLeft: `${gridSize()}px`,
  em: {
    fontStyle: 'normal',
    color: token('color.text.warning.inverse', colors.N700),
    background: token('color.background.warning.bold', colors.Y75),
  },
});

export const PathSeperator = styled.span(
  {
    margin: '0 0.5em',
  },
  media.upToMedium(`
    margin: 0 0.1em;
  `)
);
